import React from 'react';
import { Button, Layout, Footer } from 'components';
import { Row, Col } from 'antd';

import './order-successful.less';
import 'components/box/box.less';
import checked from 'assests/images/checked.png';
import { useLocation } from 'react-router-dom';

const OrderSuccessful = () => {
  let location = useLocation();
  const data = location.state;
  return (
    <Layout>
      <div className="page-order-successfull">
        <div className="container">
          <figure>
            <img  src={checked} alt="Checked Image" />
          </figure>
          <h1 className="section__title">
            Satın alımınız için teşekkür ederiz!
          </h1>
          <p className="info-text">
            Sistemde kayıtlı e-posta adresinize satın alım işleminiz ile ilgili
            bir bilgilendirme maili gönderilmiştir.
          </p>
          {data?.prize &&  
          <React.Fragment><h3 className="box__title">Sipariş Özeti</h3>
          <Row>
            <Col lg={{ span: 12, offset: 6 }} span={24}>
              <div className="box">
                <div className="table">
                  <Row className="table__row">
                    <Col md={{ span: 14 }} span={24}>
                      <strong>Paket: </strong>
                      <span>{data?.name} Paket</span>
                    </Col>
                    <Col md={{ span: 10 }} span={24}>
                      <strong>Tutar: </strong>
                      <span>{data?.prize} TL</span>
                    </Col>
                  </Row>
                  {/* <Row className='table__row'>
                    <Col md={{span: 14}} span={24}>
                      <strong>Ödeme Yöntemi:  </strong>
                      <span>{data?.paymentMethod}</span>
                    </Col>
                    <Col md={{span:10}} span={24}>
                      {data?.invoiceID && 
                        <React.Fragmant> 
                              <strong>Fatura Numarası:  </strong>
                              <span>{data?.invoiceID}</span> 
                        </React.Fragmant> 
                      }
                     
                    </Col>
                  </Row> */}
                  <div className="table__row">
                    <span className="info-text">
                      Satın aldığınız paket <strong>12 Ay</strong> süresince
                      geçerli olacaktır.{' '}
                    </span>
                  </div>
                </div>
              </div>
            </Col>
          </Row></React.Fragment> 
          }
          <Button
            type="primary"
            htmlType="submit"
            shape="round"
            className="login-button"
            href="/Messages"
          >
            Ana Sayfaya Dön
          </Button>
        </div>
      </div>
      <Footer />
    </Layout>
  );
};

export default OrderSuccessful;
